import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SearchService {

  searchQuery: string = '';

  constructor() { }

  private searchResultsSource = new BehaviorSubject<any[]>([]);
  searchResults$ = this.searchResultsSource.asObservable();

  updateSearchResults(results: any[]) {
    this.searchResultsSource.next(results);
  }
}
